import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    '#containerHeaderPutAway': {
      MozTransition: 'height .5s',
      msTransition: 'height .5s',
      OTransition: 'height .5s',
      WebkitTransition: 'height .5s',
      transition: 'height .5s',
      height: '140px',
      overflow: 'hidden',
      width: '100%'
    },
    '#containerDetails': {
      MozTransition: 'height .5s',
      msTransition: 'height .5s',
      OTransition: 'height .5s',
      WebkitTransition: 'height .5s',
      transition: 'height .5s',
      height: '0px',
      overflow: 'hidden'
    },
    details: {
      fontSize: 16
    }
  })
)
